// @ts-nocheck

import { Licences } from '../../../types/common';
import {
  MPCardBasketBROWN,
  MPCardBasketDARKBLUE,
  MPCardBasketENERGYELECTRICITY,
  MPCardBasketENERGYWATER,
  MPCardBasketGREEN,
  MPCardBasketLIGHTBLUE,
  MPCardBasketORANGE,
  MPCardBasketPURPLE,
  MPCardBasketRED,
  MPCardBasketSTATION,
  MPCardBasketYELLOW,
} from '../assets/img';
import { MPCardTypes } from '../types/cards';
import { MPFamilyIds } from '../types/families';

export const familyOrder = [
  MPFamilyIds.BROWN,
  MPFamilyIds.LIGHT_BLUE,
  MPFamilyIds.PURPLE,
  MPFamilyIds.ORANGE,
  MPFamilyIds.RED,
  MPFamilyIds.YELLOW,
  MPFamilyIds.GREEN,
  MPFamilyIds.DARK_BLUE,
  MPFamilyIds.STATION,
  MPFamilyIds.ENERGY,
];

export const MPFamilies = {
  [MPFamilyIds.BROWN]: [
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Boulevard\nde Belleville',
        [Licences.DE]: 'Badstraße',
        [Licences.ES]: 'Ronda\nde Valencia',
      },
      name: {
        [Licences.FR]: 'Boulevard de Belleville',
        [Licences.DE]: 'Badstraße',
        [Licences.ES]: 'Ronda de Valencia',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Rue\nLecourbe',
        [Licences.DE]: 'Turmstraße',
        [Licences.ES]: 'Plaza\nLavapiés',
      },
      name: {
        [Licences.FR]: 'Rue Lecourbe',
        [Licences.DE]: 'Turmstraße',
        [Licences.ES]: 'Plaza Lavapiés',
      },
    },
  ],
  [MPFamilyIds.LIGHT_BLUE]: [
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Rue de\nVaugirard',
        [Licences.DE]: 'Chaussee-\nstraße',
        [Licences.ES]: 'Glorieta\nCuatro\nCaminos',
      },
      name: {
        [Licences.FR]: 'Rue de Vaugirard',
        [Licences.DE]: 'Chausseestraße',
        [Licences.ES]: 'Glorieta Cuatro Caminos',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Rue de\nCourcelles',
        [Licences.DE]: 'Elisenstraße',
        [Licences.ES]: 'Avenida Reina\nVictoria',
      },
      name: {
        [Licences.FR]: 'Rue de Courcelles',
        [Licences.DE]: 'Elisenstraße',
        [Licences.ES]: 'Avenida Reina Victoria',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Avenue de\nla République',
        [Licences.DE]: 'Poststraße',
        [Licences.ES]: 'Calle Bravo\nMurillo',
      },
      name: {
        [Licences.FR]: 'Avenue de la République',
        [Licences.DE]: 'Poststraße',
        [Licences.ES]: 'Calle Bravo Murillo',
      },
    },
  ],
  [MPFamilyIds.PURPLE]: [
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Boulevard de\nla Villette',
        [Licences.DE]: 'Seestraße',
        [Licences.ES]: 'Glorieta\nde Bilbao',
      },
      name: {
        [Licences.FR]: 'Boulevard de la Villette',
        [Licences.DE]: 'Seestraße',
        [Licences.ES]: 'Glorieta de Bilbao',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Avenue de\nNeuilly',
        [Licences.DE]: 'Hafenstraße',
        [Licences.ES]: 'Calle Alberto\nAguilera',
      },
      name: {
        [Licences.FR]: 'Avenue de Neuilly',
        [Licences.DE]: 'Hafenstraße',
        [Licences.ES]: 'Calle Alberto Aguilera',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Rue de Paradis',
        [Licences.DE]: 'Neue Straße',
        [Licences.ES]: 'Calle\nFuencarral',
      },
      name: {
        [Licences.FR]: 'Rue de Paradis',
        [Licences.DE]: 'Neue Straße',
        [Licences.ES]: 'Calle Fuencarral',
      },
    },
  ],
  [MPFamilyIds.ORANGE]: [
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Avenue\nMozart',
        [Licences.DE]: 'Münchener\nStraße',
        [Licences.ES]: 'Avenida\nFelipe II',
      },
      name: {
        [Licences.FR]: 'Avenue Mozart',
        [Licences.DE]: 'Münchener Straße',
        [Licences.ES]: 'Avenida Felipe II',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Boulevard\nSaint-Michel',
        [Licences.DE]: 'Wiener\nStraße',
        [Licences.ES]: 'Calle\nVelázquez',
      },
      name: {
        [Licences.FR]: 'Boulevard Saint-Michel',
        [Licences.DE]: 'Wiener Straße',
        [Licences.ES]: 'Calle Velázquez',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Place Pigalle',
        [Licences.DE]: 'Berliner\nStraße',
        [Licences.ES]: 'Calle\nSerrano',
      },
      name: {
        [Licences.FR]: 'Place Pigalle',
        [Licences.DE]: 'Berliner Straße',
        [Licences.ES]: 'Calle Serrano',
      },
    },
  ],
  [MPFamilyIds.RED]: [
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Avenue\nMatignon',
        [Licences.DE]: 'Theater-\nstraße',
        [Licences.ES]: 'Avenida\nde América',
      },
      name: {
        [Licences.FR]: 'Avenue Matignon',
        [Licences.DE]: 'Theaterstraße',
        [Licences.ES]: 'Avenida de América',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Boulevard\nMalesherbes',
        [Licences.DE]: 'Museum-\nstraße',
        [Licences.ES]: 'Calle\nde Molina',
      },
      name: {
        [Licences.FR]: 'Boulevard Malesherbes',
        [Licences.DE]: 'Museumstraße',
        [Licences.ES]: 'Calle de Molina',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Avenue\nHenri-Martin',
        [Licences.DE]: 'Opernplatz',
        [Licences.ES]: 'Calle Cea\nBermúdez',
      },
      name: {
        [Licences.FR]: 'Avenue Henri-Martin',
        [Licences.DE]: 'Opernplatz',
        [Licences.ES]: 'Calle Cea Bermúdez',
      },
    },
  ],
  [MPFamilyIds.YELLOW]: [
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Faubourg\nSaint-Honoré',
        [Licences.DE]: 'Lessing-\nstraße',
        [Licences.ES]: 'Avenida de\nlos Reyes\nCatólicos',
      },
      name: {
        [Licences.FR]: 'Faubourg Saint-Honoré',
        [Licences.DE]: 'Lessingstraße',
        [Licences.ES]: 'Avenida de los Reyes Católicos',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Place de\nla Bourse',
        [Licences.DE]: 'Schiller-\nstraße',
        [Licences.ES]: 'Calle\nBailén',
      },
      name: {
        [Licences.FR]: 'Place de la Bourse',
        [Licences.DE]: 'Schillerstraße',
        [Licences.ES]: 'Calle Bailén',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Rue\nLa Fayette',
        [Licences.DE]: 'Goethe-\nstraße',
        [Licences.ES]: 'Plaza\nde España',
      },
      name: {
        [Licences.FR]: 'Rue La Fayette',
        [Licences.DE]: 'Goethestraße',
        [Licences.ES]: 'Plaza de España',
      },
    },
  ],
  [MPFamilyIds.GREEN]: [
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Avenue de\nBreteuil',
        [Licences.DE]: 'Rathausplatz',
        [Licences.ES]: 'Puerta\ndel Sol',
      },
      name: {
        [Licences.FR]: 'Avenue de Breteuil',
        [Licences.DE]: 'Rathausplatz',
        [Licences.ES]: 'Puerta del Sol',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Avenue Foch',
        [Licences.DE]: 'Hauptstraße',
        [Licences.ES]: 'Calle\nAlcalá',
      },
      name: {
        [Licences.FR]: 'Avenue Foch',
        [Licences.DE]: 'Hauptstraße',
        [Licences.ES]: 'Calle Alcalá',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Boulevard\ndes Capucines',
        [Licences.DE]: 'Bahnhof-\nstraße',
        [Licences.ES]: 'Gran\nVía',
      },
      name: {
        [Licences.FR]: 'Boulevard des Capucines',
        [Licences.DE]: 'Bahnhofstraße',
        [Licences.ES]: 'Gran Vía',
      },
    },
  ],
  [MPFamilyIds.DARK_BLUE]: [
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Avenue des\nChamps-Élysées',
        [Licences.DE]: 'Parkstraße',
        [Licences.ES]: 'Paseo de la\nCastellana',
      },
      name: {
        [Licences.FR]: 'Avenue des Champs-Élysées',
        [Licences.DE]: 'Parkstraße',
        [Licences.ES]: 'Paseo de la Castellana',
      },
    },
    {
      type: MPCardTypes.COLOR,
      nameCard: {
        [Licences.FR]: 'Rue de la Paix',
        [Licences.DE]: 'Schlossallee',
        [Licences.ES]: 'Paseo del\nPrado',
      },
      name: {
        [Licences.FR]: 'Rue de la Paix',
        [Licences.DE]: 'Schlossallee',
        [Licences.ES]: 'Paseo del Prado',
      },
    },
  ],
  [MPFamilyIds.STATION]: [
    {
      type: MPCardTypes.STATION,
      nameCard: {
        [Licences.FR]: 'Gare\nMontparnasse',
        [Licences.DE]: 'Nordbahnhof',
        [Licences.ES]: 'Estación\nde las Delicias',
      },
      name: {
        [Licences.FR]: 'Gare Montparnasse',
        [Licences.DE]: 'Nordbahnhof',
        [Licences.ES]: 'Estación de las Delicias',
      },
    },
    {
      type: MPCardTypes.STATION,
      nameCard: {
        [Licences.FR]: 'Gare de Lyon',
        [Licences.DE]: 'Westbahnhof',
        [Licences.ES]: 'Estación\ndel Mediodía',
      },
      name: {
        [Licences.FR]: 'Gare de Lyon',
        [Licences.DE]: 'Westbahnhof',
        [Licences.ES]: 'Estación del Mediodía',
      },
    },
    {
      type: MPCardTypes.STATION,
      nameCard: {
        [Licences.FR]: 'Gare du Nord',
        [Licences.DE]: 'Südbahnhof',
        [Licences.ES]: 'Estación\ndel Norte',
      },
      name: {
        [Licences.FR]: 'Gare du Nord',
        [Licences.DE]: 'Südbahnhof',
        [Licences.ES]: 'Estación del Norte',
      },
    },
    {
      type: MPCardTypes.STATION,
      nameCard: {
        [Licences.FR]: 'Gare\nSaint-Lazare',
        [Licences.DE]: 'Hauptbahnhof',
        [Licences.ES]: 'Estación\nde Goya',
      },
      name: {
        [Licences.FR]: 'Gare Saint-Lazare',
        [Licences.DE]: 'Hauptbahnhof',
        [Licences.ES]: 'Estación de Goya',
      },
    },
  ],
  [MPFamilyIds.ENERGY]: [
    {
      type: MPCardTypes.ELECTRICITY,
      nameCard: {
        [Licences.FR]: "Compagnie de\ndistribution\nd'électricité",
        [Licences.DE]: 'Elektrizitäts-\nwerk',
        [Licences.ES]: 'Compañía de\nelectricidad',
      },
      name: {
        [Licences.FR]: "Compagnie de distribution d'électricité",
        [Licences.DE]: 'Elektrizitätswerk',
        [Licences.ES]: 'Compañía de electricidad',
      },
    },
    {
      type: MPCardTypes.WATER,
      nameCard: {
        [Licences.FR]: 'Compagnie de\ndistribution\ndes eaux',
        [Licences.DE]: 'Wasserwerk',
        [Licences.ES]: 'Compañía\nde aguas',
      },
      name: {
        [Licences.FR]: 'Compagnie de distribution des eaux',
        [Licences.DE]: 'Wasserwerk',
        [Licences.ES]: 'Compañía de aguas',
      },
    },
  ],
};

export const MPSmallCardIconImgPaths = {
  [MPFamilyIds.BROWN]: MPCardBasketBROWN,
  [MPFamilyIds.LIGHT_BLUE]: MPCardBasketLIGHTBLUE,
  [MPFamilyIds.PURPLE]: MPCardBasketPURPLE,
  [MPFamilyIds.ORANGE]: MPCardBasketORANGE,
  [MPFamilyIds.RED]: MPCardBasketRED,
  [MPFamilyIds.YELLOW]: MPCardBasketYELLOW,
  [MPFamilyIds.GREEN]: MPCardBasketGREEN,
  [MPFamilyIds.DARK_BLUE]: MPCardBasketDARKBLUE,
  [MPFamilyIds.STATION]: MPCardBasketSTATION,
  [MPCardTypes.ELECTRICITY]: MPCardBasketENERGYELECTRICITY,
  [MPCardTypes.WATER]: MPCardBasketENERGYWATER,
};
